import "./icon-chevron.css.ts.vanilla.css-mistica.js";
var o = "_77bqcx2", a = "_77bqcx1", n = {
    transitionDuration: "var(--_77bqcx0)"
};
export { o as chevronColorTransition, a as chevronRotateTransition, n as vars };
